export default __webpack_public_path__ + "static/media/pensioner-info.e839c6ed.svg";